// Space left below an overlay before the frame edge, so it never sits flush.
const VIEWPORT_GAP = 16

// Caps a floating overlay to what the frame can actually show.
//
// widgets.init_iframe sizes the portal iframe from the smaller of html/body
// scrollHeight, which discards an absolutely positioned element - so on a page
// too short to have grown the frame already, the overlay is cut off at the
// frame edge. Capping it here keeps every row reachable by scrolling instead.
//
// Only absolutely positioned overlays: an in-flow panel (the mobile sheet's
// search results) is flex-sized by its container, and an inline max-height
// would override that.
export const capHeightToFrame = (element, maxHeight, gap = VIEWPORT_GAP) => {
  if (!element || window.getComputedStyle(element).position !== 'absolute') {
    return
  }

  const available = window.innerHeight - element.getBoundingClientRect().top - gap
  element.style.maxHeight = `${Math.min(maxHeight, Math.max(0, available))}px`
}

// The sheet's geometry inside a frame on a foreign host (utils/visible_slice):
// the dialog is anchored to the frame's bottom edge (`bottom: 0`) and reaches
// up to the same share of the visible slice a sheet takes of a real viewport,
// so the strip of blurred page above it keeps one size as the host scrolls
// and the bottom edge never moves. Only the top `visibleHeight` of it holds
// the header, search and list, so the list still scrolls within the screen;
// the rest is the surface covering the rows down to the frame's edge.
export const sheetFromVisibleSlice = (slice, frameHeight, ratio) => {
  const visibleHeight = Math.round(slice.height * ratio)

  return {
    height: Math.max(visibleHeight, Math.round(frameHeight - slice.top - slice.height * (1 - ratio))),
    bottom: 0,
    visibleHeight,
  }
}
